import { useQuery, gql } from '@apollo/client';
import { useMemo } from 'react';

import {
  type InventoryPolicy,
  type LeadTimeArray,
  calculateAvailabilityAndLeadTime,
} from '../../helpers/availability-lead-time';

const GET_PRODUCT_BY_HANDLE = gql`
  query getProductByHandle($handle: String!) {
    product(handle: $handle) {
      totalInventory
      title
    }
  }
`;

export const useProductLeadtime = (
  productHandle: string,
  leadTimeArray: LeadTimeArray,
  inventoryPolicy: InventoryPolicy,
  defaultInventoryQuantity?: number,
  useUp?: boolean
) => {
  const { data } = useQuery(GET_PRODUCT_BY_HANDLE, { variables: { handle: productHandle } });

  const values = useMemo(() => {
    const inventoryQuantity: number = data?.product?.totalInventory ?? defaultInventoryQuantity;
    const backupTitle: string | undefined = data?.product?.title;

    return {
      inventoryQuantity,
      ...calculateAvailabilityAndLeadTime(leadTimeArray, inventoryQuantity, inventoryPolicy, 1, useUp),
      backupTitle,
    };
  }, [data]);

  return values;
};
